import { Link } from 'react-router-dom';

const entries = [
  {
    type: 'movie',
    label: '电影',
    en: 'Movies',
    desc: '剧情长片、类型佳作与年度新片，按地区与评分精准筛选。',
    icon: 'ri-film-line',
    count: '1200+',
    image:
      'https://readdy.ai/api/search-image?query=Artistic%20abstract%20cinema%20scene%20with%20empty%20vintage%20theatre%20seats%20and%20warm%20orange%20projector%20beam%2C%20deep%20charcoal%20tones%2C%20minimal%20editorial%20composition%2C%20soft%20haze&width=800&height=600&seq=sigua-cat-movie&orientation=landscape',
  },
  {
    type: 'tv',
    label: '电视剧',
    en: 'Series',
    desc: '都市、家庭、悬疑长剧集，更新进度一目了然，追剧不迷路。',
    icon: 'ri-tv-2-line',
    count: '860+',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20night%20living%20room%20scene%20with%20warm%20lamplight%20and%20soft%20curtain%2C%20cozy%20cinematic%20atmosphere%20in%20amber%20and%20cream%20tones%2C%20editorial%20interior%20photography&width=800&height=600&seq=sigua-cat-tv&orientation=landscape',
  },
  {
    type: 'variety',
    label: '综艺',
    en: 'Variety',
    desc: '美食、音乐、竞技与访谈节目，慢节奏与热闹感都在这儿。',
    icon: 'ri-mic-line',
    count: '540+',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20stage%20with%20spotlight%20and%20microphone%20in%20a%20minimal%20studio%2C%20amber%20and%20deep%20brown%20tones%2C%20artistic%20editorial%20photography%2C%20soft%20glow&width=800&height=600&seq=sigua-cat-variety&orientation=landscape',
  },
];

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 md:px-8 -mt-8 relative z-10">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-5">
        {entries.map((entry, i) => (
          <Link
            key={entry.type}
            to={`/category/${entry.type}`}
            className={`group relative rounded-lg overflow-hidden bg-foreground-950 h-36 md:h-40 animate-fade-up`}
            style={{ animationDelay: `${i * 90}ms` }}
          >
            <img
              src={entry.image}
              alt={`${entry.label}频道`}
              className="absolute inset-0 w-full h-full object-cover object-top opacity-70 transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-black/20"></div>
            <div className="relative h-full px-5 flex items-center gap-4">
              <span className="w-11 h-11 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center shrink-0">
                <i className={`${entry.icon} text-xl`}></i>
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <h2 className="font-heading text-lg font-bold text-white">{entry.label}</h2>
                  <span className="font-label text-[10px] tracking-widest uppercase text-white/60">
                    {entry.en}
                  </span>
                </div>
                <p className="mt-1 text-xs text-white/70 leading-relaxed line-clamp-2">{entry.desc}</p>
              </div>
              <i className="ri-arrow-right-line ml-auto text-white/70 group-hover:text-primary-400 group-hover:translate-x-1 transition-all"></i>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}